/* tslint:disable */
/* eslint-disable */
/**
 * Careplatform Authentication API
 * An API to use to authenticate users
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: bjorn.naeslund@r2m.se
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface VerifyCodeResponse
 */
export interface VerifyCodeResponse {
    /**
     * UUID of the authenticated user
     * @type {string}
     * @memberof VerifyCodeResponse
     */
    userId: string;
    /**
     * Access token to use for authentication
     * @type {string}
     * @memberof VerifyCodeResponse
     */
    token: string;
}

export function VerifyCodeResponseFromJSON(json: any): VerifyCodeResponse {
    return VerifyCodeResponseFromJSONTyped(json, false);
}

export function VerifyCodeResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): VerifyCodeResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'userId': json['userId'],
        'token': json['token'],
    };
}

export function VerifyCodeResponseToJSON(value?: VerifyCodeResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'userId': value.userId,
        'token': value.token,
    };
}


